import { OptionsApi, WebinarDataWithAssets } from '@core/swagger-client';
import { Heading, Podcast } from '@core/ui';
import { Link } from '@online-webinar/ui-frontend';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface RelatedWebinarsProps {
    webinar: WebinarDataWithAssets;
}

// Webinar -> its related podcast webinar. Vul hier de juiste podcast webinar id in.
const relatedPodcasts: Record<string, string> = {
    'd64b55c0-cb5c-4d1d-a922-aaf2a906b0a5': '18787679-43cf-44ea-a925-766b58f82459',
    '1ade5dfb-4851-48db-b169-0ffb2f452d17': '6ba3ee66-360b-4434-bd00-d3ea8e65bd6e',
    '53d53825-a2d7-4513-a156-84cbf865137b': 'a676cd74-f1d2-4b40-9f9f-0a8f5668f73a'
};

export const RelatedWebinars = ({ webinar }: RelatedWebinarsProps) => {
    const { t } = useTranslation();
    const relatedWebinarId = relatedPodcasts[webinar.webinarId];
    const { data: relatedWebinar } = useQuery(OptionsApi.interest.getStatus(relatedWebinarId ?? '', { enabled: !!relatedWebinarId }));
    const relatedWebinars = relatedWebinar ? [relatedWebinar] : [];

    return (
        <>
            {relatedWebinars.length > 0 && (
                <div className="flex flex-col items-start gap-4 pt-10 pb-4">
                    <Heading variant="h2">{t('WebinarDetails.Heading.Related')}</Heading>
                    {relatedWebinars.length > 0 &&
                        relatedWebinars.map((relatedWebinar) => (
                            <Link variant="link" to="/$webinarId" params={{ webinarId: relatedWebinar.webinarId }} key={relatedWebinar.webinarId}>
                                <Podcast classNames="size-8 fill-current mr-3" />
                                {relatedWebinar.title}
                            </Link>
                        ))}
                </div>
            )}
        </>
    );
};
